import { IFeatureState } from './types';

export const FeatureOn = ({ children, enabled }: IFeatureState) => <>{enabled && children}</>;
